import React, { Component } from 'react';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';

import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import { getApi } from "../App";

/* ---------- Helpers de fecha ---------- */

// Convierte props/strings ISO (con o sin offset) a 'YYYY-MM-DD' en horario LOCAL
function normalizeFechaToYMD(fecha) {
  if (!fecha) return '';
  const s = String(fecha).trim();

  // Si ya empieza con YYYY-MM-DD, úsalo directo
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[1]}-${m[2]}-${m[3]}`;

  // Si viene con offset sin ":" (ej. +0000 / -0300), insértalo
  const withColonOffset = s.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');

  const d = new Date(withColonOffset);
  if (!isNaN(d)) {
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 10);
  }

  // Último recurso: extraer YYYY-MM-DD si está presente
  const m2 = withColonOffset.match(/(\d{4}-\d{2}-\d{2})/);
  return m2 ? m2[1] : '';
}

// Convierte 'YYYY-MM-DD' -> 'YYYY-MM-DDT00:00:00.000±HH:mm' según zona local
function toLocalOffsetISO(dateStr) {
  if (!dateStr) return undefined;
  const offsetMin = -new Date().getTimezoneOffset(); // invierte signo para ±HH:mm
  const sign = offsetMin >= 0 ? '+' : '-';
  const abs = Math.abs(offsetMin);
  const hh = String(Math.floor(abs / 60)).padStart(2, '0');
  const mm = String(abs % 60).padStart(2, '0');
  return `${dateStr}T00:00:00.000${sign}${hh}:${mm}`;
}

// "Hoy" como YYYY-MM-DD en local
function todayYMDLocal() {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
}

/* ---------- Componente ---------- */

export class AddTramitesModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tipoTramites: [],
      fechaTramite: todayYMDLocal(), // YYYY-MM-DD controlado
      tipoTramite: 0,                // se ajusta al primer tipo disponible al montar
      snackbarOpen: false,
      snackbarmsg: ''
    };

    // binds (evitan "this is undefined")
    this.snackbarClose = this.snackbarClose.bind(this);
    this.handleFechaChange = this.handleFechaChange.bind(this);
    this.handleTipoChange = this.handleTipoChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    getApi()
      .getTipoTramites()
      .then((data) => {
        const lista = data || [];
        this.setState((prev) => ({
          tipoTramites: lista,
          tipoTramite: prev.tipoTramite || (lista[0]?.identificador ?? 0)
        }));
      });
  }

  // Re-inicializa campos al abrir modal o cambiar de expediente
  componentDidUpdate(prevProps) {
    const openedNow = !prevProps.show && this.props.show;
    const changedExpediente = prevProps.idExpediente !== this.props.idExpediente;

    if (openedNow || changedExpediente) {
      this.setState({
        fechaTramite: todayYMDLocal(),
        tipoTramite: this.state.tipoTramites[0]?.identificador ?? 0
      });
    }
  }

  snackbarClose() {
    this.setState({ snackbarOpen: false });
  }

  handleFechaChange(event) {
    this.setState({ fechaTramite: event.target.value }); // YYYY-MM-DD
  }

  handleTipoChange(event) {
    this.setState({ tipoTramite: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();

    const fechaISOConOffset = toLocalOffsetISO(this.state.fechaTramite);

    const data = {
      id: null,
      idExpediente: this.props.idExpediente,
      tipoTramite: this.state.tipoTramite,
      // Recomendado: enviar con offset local
      fechaHora: fechaISOConOffset,
      // Si el backend espera solo fecha (LocalDate), usa:
      // fechaHora: this.state.fechaTramite,
      responsable: event.target.resposable.value, // el name del input es 'resposable'
      observ: event.target.observ.value
    };

    getApi()
      .saveTramites(data)
      .then((res) => res.json())
      .catch((error) => {
        console.error('Error:', error);
      })
      .then((response) => {
        // éxito
        this.setState({ snackbarOpen: true, snackbarmsg: 'El registro se guardó correctamente' });
        this.props.onClose();
      });
  }

  render() {
    const { fechaTramite, tipoTramite, tipoTramites, snackbarOpen, snackbarmsg } = this.state;

    return (
      <div className="container">
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={this.snackbarClose}
          message={<span id="message-id">{snackbarmsg}</span>}
          action={[
            <IconButton key="close" arial-label="Cerrar" color="inherit" onClick={this.snackbarClose}>
              x
            </IconButton>
          ]}
        />
        <Modal
          key={this.props.idExpediente} // fuerza remount al cambiar de expediente
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained_modal_title_vcenter">
              Agregar Trámites al expediente {this.props.idExpediente}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={6}>
                <Form onSubmit={this.handleSubmit}>
                  <Form.Group controlId="fecha">
                    <Form.Label>Fecha:</Form.Label>
                    <Form.Control
                      onChange={this.handleFechaChange}
                      type="date"
                      name="fecha"
                      value={fechaTramite || ''}
                      required
                      placeholder="Fecha del Trámite"
                    />
                  </Form.Group>

                  <Form.Group controlId="resposable">
                    <Form.Label>Responsable:</Form.Label>
                    <Form.Control
                      type="text"
                      name="resposable"
                      maxLength="100"
                      placeholder="Responsable"
                    />
                  </Form.Group>

                  <Form.Group controlId="selectTipoTramite">
                    <Form.Label htmlFor="selectTipoTramite">Trámites</Form.Label>
                    <Form.Control
                      as="select"
                      id="selectTipoTramite"
                      value={tipoTramite}
                      onChange={this.handleTipoChange}
                    >
                      {tipoTramites.map((tp) => (
                        <option key={tp.identificador} value={tp.identificador}>
                          {tp.descrip}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>

                  <Form.Group controlId="observ">
                    <Form.Label>Observación:</Form.Label>
                    <Form.Control
                      type="text"
                      name="observ"
                      maxLength="100"
                      placeholder="Observación"
                    />
                  </Form.Group>

                  <Form.Group>
                    <Button variant="primary" type="submit">
                      Grabar
                    </Button>
                  </Form.Group>
                </Form>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={this.props.onHide}>
              Cerrar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddTramitesModal;
